export const TENANT_ID = "medibank-valencia";
export const APP_ID = "medibank-valencia-web";

export const MASONRY = {
  ROOT_NODE_ID_HOME_PAGE: "homepage$root",
};
